import script from "./serviceadvantagesview.vue?vue&type=script&setup=true&lang=js"
export * from "./serviceadvantagesview.vue?vue&type=script&setup=true&lang=js"

import "./serviceadvantagesview.vue?vue&type=style&index=0&id=2665d2c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2665d2c0"]])

export default __exports__